module.exports = __webpack_public_path__ + "static/w-miranti-3b1e7162936c9dfd276bebcd0d7043ae.jpg";